﻿

window.grid = function () {

    var exportFlag = false;

    return {

        //
        // Template for boolean columns.
        // Will show check mark when true.
        //
        booleanTemplate: function (data) {

            var image = "";

            if (data) {
                image = appsettings.getUrl('images/svg/Check.svg');
            }
            else {
                image = appsettings.getUrl('images/svg/Multiply.svg');
            }

            return "<div style='text-align: center;'><img src=" + image + " style = 'width:21px; height:21px;'></div>";
        },


        //
        // Exports all defined columns in the grid even if they are hidden.
        // https://www.telerik.com/forums/exporting-all-the-columns-to-excel
        //
        exportExcellAllFields: function (e) {

            var sheet = e.workbook.sheets[0];
            var data = e.data;
            var gridColumns = e.sender.columns;
            var columns = gridColumns.map(function (col) {
                return {
                    value: col.title ? col.title : col.field,
                    autoWidth: true,
                    background: "#7a7a7a",
                    color: "#fff"
                };
            });

            var rows = [{ cells: columns, type: "header" }];

            for (var i = 0; i < data.length; i++) {
                var rowCells = [];
                for (var j = 0; j < gridColumns.length; j++) {
                    var cellValue = data[i][gridColumns[j].field];
                    rowCells.push({ value: cellValue });
                }
                rows.push({ cells: rowCells, type: "data" });
            }
            sheet.rows = rows;
        },


        //
        // Exports all defined columns in the grid even if they are hidden.
        // Temporarily sets hidden columns to show and back.
        // https://docs.telerik.com/kendo-ui/knowledge-base/grid-include-hidden-columns-to-exported-pdf
        //
        exportPdfAllFields: function (e) {

            if (!exportFlag) {

                var gridColumns = e.sender.columns;
                var hiddenArr = [];

                for (var i = 0; i < gridColumns.length; i++) {
                    if (gridColumns[i].hidden) {
                        hiddenArr.push(i);
                        e.sender.showColumn(i);
                    }                    
                }

                e.preventDefault();
                exportFlag = true;

                e.sender.saveAsPDF().then(function () {
                    for (var i = 0; i < hiddenArr.length; i++) {
                        e.sender.hideColumn(hiddenArr[i]);
                    }
                    exportFlag = false;
                });
            }
        }

    }

}();
